import { Button, Dialog } from '@buffer-mono/popcorn'
import { Limits } from '../../constants'
import styles from './HardLimitReachedDialog.module.css'
import clsx from 'clsx'
import { TrackRender } from '~publish/hooks/tracking'

export const HardLimitReachedDialog = ({
  enabled,
  type,
  tier,
  className,
  children,
  onOpenChange,
}: {
  enabled?: boolean
  type: 'feeds' | 'collections' | 'feedspercollection'
  tier: 'free' | 'paid'
  className?: string
  children: JSX.Element
  onOpenChange?: (open: boolean) => void
}): JSX.Element => {
  if (!enabled) {
    return children
  }

  const messageContext = {
    feeds: {
      limit: Limits.feeds[tier].total,
      item: 'feeds',
      addMore: 'feeds',
    },
    collections: {
      limit: Limits.collections[tier],
      item: 'collections',
      addMore: 'collections',
    },
    feedspercollection: {
      limit: Limits.feeds[tier].perCollection,
      item: 'feeds per collection',
      addMore: 'feeds to this collection',
    },
  }[type]

  return (
    <Dialog key="hardLimitReachedDialog" onOpenChange={onOpenChange}>
      {/* asChild needs to be false to support multiple conditional dialogs around one trigger */}
      <Dialog.Trigger
        asChild={false}
        className={clsx(styles.trigger, className)}
      >
        {children}
      </Dialog.Trigger>
      <Dialog.Content>
        <Dialog.Header>
          <Dialog.Title>Limit Reached!</Dialog.Title>
          <Dialog.Description>
            You have reached the limit of {messageContext.limit}{' '}
            {messageContext.item}. Adding more {messageContext.addMore} is
            currently not supported.
          </Dialog.Description>
          <TrackRender componentName="HardLimitReachedDialog" type={type} />
        </Dialog.Header>
        <Dialog.Footer>
          <Dialog.Close>
            <Button variant="primary" size="large">
              Got it
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
